import { Component, Input } from '@angular/core';

import { Tenant } from '@libs/src/tenant/tenant.interface';

@Component({
  selector: 'app-avatar-tenant',
  templateUrl: './avatar-tenant.component.html',
})
export class AvatarTenantComponent {
  @Input()
  item: Tenant;
  @Input()
  size: number;
}
